import { axios } from '@/util/axios.js';
const baseUrl = '/api'
function handlerPaging(params={}){
    let {page,limit} = params;
    let pn = parseInt(page),ps = parseInt(limit);
    if(isNaN(pn) || pn < 0 ){
      pn = 1;
    }
    if(isNaN(ps) || ps < 1 ){
      ps = 10;
    }
    return Object.assign(params,{page:pn,limit:ps})
  }
/*生成报告*/
export function addReport(params={},callback){
    return axios.request({
      "url" : baseUrl+"/report_actions/"+params.customer_id+"/",
      "method" : "post",
      "data":params
    },callback)
}
/*获取报告列表*/
export function getReportList(params={},callback){
    handlerPaging(params.data);
    return axios.request({
        "url" : baseUrl+"/report_actions/"+params.data.customer_id+"/",
        "method" : "get",
        "params": params.data
    },callback)
}
/*删除报告*/
export function deleteReport(params={},callback){
    return axios.request({
        "url" : baseUrl+"/report_actions/"+params.customer_id+'/',
        "method" : "delete",
        "data": params.data
    },callback)
}
/*获取报告详情*/
export function getReportDetail(params={},callback){
    return axios.request({
        "url" : baseUrl+"/reports/"+params.report_id+'/',
        "method" : "get",
    },callback)
}

/*获取告警数据分片*/
export function getAlarmChunk(params={},callback){
    return axios.request({
        "url" : baseUrl+"/reports/alarm_chunk/"+params.report_id+'/',
        "method" : "get",
        "params": params.data
    },callback)
}
/*获取设备数据分片*/
export function getEquipmentChunk(params={},callback){
    return axios.request({
        "url" : baseUrl+"/reports/equipment_chunk/"+params.report_id+'/',
        "method" : "get",
        "params": params.data
    },callback)
}
/*获取趋势数据分片*/
export function getTrendChunk(params={},callback){
    return axios.request({
        "url" : baseUrl+"/reports/equipment_trend_chunk/"+params.report_id+'/',
        "method" : "get",
        "params": params.data
    },callback)
}
/*获取趋势数据分片*/
export function getChunkInfoFromReport(params={},callback){
    return axios.request({
        "url" : baseUrl+"/report_equipment_info/"+params.report_id+'/',
        "method" : "get",
    },callback)
}






// /* 新增公司 ok*/
// export function addCompany(params={},callback){
//     return axios.request({
//       "url" : baseUrl+"/customers/",
//       "method" : "post",
//       "data":params
//     },callback)
// }
// /* 修改公司*/
// export function editCompany(params={},callback){
//   return axios.request({
//     "url" : baseUrl+"/customers/"+params.customer_id+'/',
//     "method" : "put",
//     "data":params.params
//   },callback)
// }
// /* 公司详情ok */  
// export function companyDetails(params={},callback){
//   return axios.request({
//     "url" : baseUrl+"/customers/"+params.customer_id+'/',
//     "method" : "get",
//   },callback)
// }
// /* 删除公司ok */
// export function delCompany(params={},callback){
//   return axios.request({
//     "url" : baseUrl+"/customers/"+params.customer_id+'/?clear_resource='+params.isClear,
//     "method" : "delete",
//   },callback)
// }
// /* 公司下所有站点详情 */  
// export function companySitesDetails(params={},callback){
//   return axios.request({
//     "url" : baseUrl+"/customer_sites/"+params.customer_id+'/',
//     "method" : "get",
//   },callback)
// }
// /* 新增站点ok */
// export function addSite(params={},callback){
//     return axios.request({
//       "url" : baseUrl+"/customer_sites/"+params.parent_id+'/',
//       "method" : "post",
//       "data":params.params
//     },callback)
// }
// /* 修改站点*/
// export function editSite(params={},callback){
//   return axios.request({
//     "url" : baseUrl+"/customer/"+params.customer_id+'/sites/'+params.site_id+'/',
//     "method" : "put",
//     "data":params.params
//   },callback)
// }
// /* 删除站点ok */
// export function delSite(params={},callback){
//   return axios.request({
//     "url" : baseUrl+"/customer/"+params.customer_id+'/sites/'+params.site_id+'/?clear_resource='+params.isClear,
//     "method" : "delete",
//   },callback)
// }
// /* 站点详情 */
// export function siteDetails(params={},callback){
//   return axios.request({
//     "url" : baseUrl+"/customer/"+params.customer_id+'/sites/'+params.site_id+'/',
//     "method" : "get",
//   },callback)
// }
// /* 站点下设备详情 */
// export function siteDeviceDetails(params={},callback){
//   return axios.request({
//     "url" : baseUrl+"/sites/"+params.site_id+'/equipment/',
//     "method" : "get",
//   },callback)
// }

// /* 新增设备ok */
// export function addDevice(params={},callback){
//     return axios.request({
//       "url" : baseUrl+"/sites/"+ params.site_id +"/equipment/",
//       "method" : "post",
//       "data":params.params
//     },callback)
// }
// /* 删除设备 */
// export function delDevice(params={},callback){
//   return axios.request({
//     "url" : baseUrl+"/sites/"+params.site_id+'/equipments/'+params.equipment_id+'/?clear_resource='+params.isClear,
//     "method" : "delete",
//   },callback)
// }
// /* 修改设备*/
// export function editDevice(params={},callback){
//   return axios.request({
//     "url" : baseUrl+"/sites/"+params.site_id+'/equipments/'+params.equipment_id+'/',
//     "method" : "put",
//     "data":params.params
//   },callback)
// }
// /* 设备详情 */
// export function deviceDetails(params={},callback){
//   return axios.request({
//     "url" : baseUrl+"/sites/"+params.site_id+'/equipments/'+params.device_id+'/',
//     "method" : "get",
//   },callback)
// }

// /* 新增测点ok */
// export function addPoint(params={},callback){
//     return axios.request({
//       "url" : baseUrl+"/equipment/"+params.device_id+"/point/",
//       "method" : "post",
//       "data":params.params
//     },callback)
// }

// /* 修改测点*/
// export function editPoint(params={},callback){
//   return axios.request({
//     "url" : baseUrl+"/equipment/"+params.equipment_id+'/point/'+params.point_id+'/',
//     "method" : "put",
//     "data":params.params
//   },callback)
// }
// /* 单个测点详情 */
// export function pointDetails(params={},callback){
//   return axios.request({
//     "url" : baseUrl+"/equipment/"+params.equipment_id +"/point/"+params.point_id+'/' ,
//     "method" : "get",
//   },callback)
// }

// /* 删除测点 */
// export function delPoint(params={},callback){
//   return axios.request({
//     "url" : baseUrl+"/equipment/"+params.equipment_id+'/point/'+params.point_id+'/?clear_resource='+params.isClear,
//     "method" : "delete",
//   },callback)
// }


// /*导入档案*/ 
// export function importFile(params={},callback){
//   return axios.request({
//     "url" : baseUrl+"/file_import/",
//     "method" : "post",
//     "data":params.data
//   },callback)
// }

// /* 站点下未绑定的传感器 */
// export function queryUnbindSensor(params={},callback){
//     return axios.request({
//       "url" : baseUrl+'/sites/'+params.site_id+'/sensor_configs/',
//       "method" : "get",
//       "params":params.data
//     },callback)
// }

// /* 档案导出 */
// export function fileExport(params={},callback){
//     return axios.request({
//       "url" : baseUrl+'/cloud_file_export/',
//         "method": "get",
//         "responseType": "blob",
//       "params":params
//     },callback)
// }

// /* 档案导出模版 */
// export function fileTemplateExport(params={},callback){
//     return axios.request({
//       "url" : baseUrl+'/cloud_template_file/',
//         "method": "get",
//         "responseType": "blob",
//       "params":params
//     },callback)
// }


// /* 测点下传感器列表接口 */
// export function getEquipmentSensor(params = {}, callback) {
//     return axios.request({
//         "url" : baseUrl+'/equipments/'+params.equipment_id+'/sensor_info/',
//           "method": "get",
//         // "params":params
//       },callback) 
// }

// /* 站点下传感器列表接口 */
// export function getSiteSensor(params = {}, callback) {
//     return axios.request({
//         "url" : baseUrl+'/sites/'+params.site_id+'/sensor_info/',
//           "method": "get",
//         // "params":params
//       },callback) 
// }

// export function exportTerndDetail(point_id, formData, callback){
//   return axios.request({
//     "url" : baseUrl+'/trend_export/' + point_id + '/',
//       "method": "post",
//       "responseType": "blob",
//       "headers": {
//         "Content-Type": "multipart/form-data"  // 符合文件上传格式
//       },
//       "data": formData
//   },callback)
// }

// export function exportSingleDetail(params={},formData,callback){
//   return axios.request({
//     "url" : baseUrl+'/export_sensor/' + params.sensor_data_id + '/sensor_type/' + params.sensor_type + '/',
//       "method": "post",
//       "responseType": "blob",
//       "headers": {
//         "Content-Type": "multipart/form-data"  // 符合文件上传格式
//       },
//       "data": formData
//   },callback)
// }


// WEBPACK FOOTER //
// ./src/data/report.js